module.exports = __webpack_public_path__ + "img/creatures.a39b6808.svg";